import { Box, Typography } from "@mui/material";
import CarretDown from "../../../../assets/svg-fc/CarretDown";
import "./sectionHeader.scss";

interface ISectionHeaderProps {
	title: string;
	collapse: boolean;
	collapseMultiple?: boolean;
	setCollapse: (collapse: boolean) => void;
}

const SectionHeader = ({ title, collapse, collapseMultiple, setCollapse }: ISectionHeaderProps) => {
	return (
		<Box className="sectionHeader">
			<Typography variant="h6" className="sectionTitle">
				{title}
			</Typography>
			<Box className="sectionHeaderRight" onClick={() => setCollapse(!collapse)}>
				<Typography className="sectionHeaderRightText">
					{collapse ? "Expand" : "Collapse"} {collapseMultiple ? "all" : ""}
				</Typography>
				<CarretDown style={{ transform: collapse ? "rotate(0deg)" : "rotate(180deg)" }} />
			</Box>
		</Box>
	);
};

export default SectionHeader;
